import {authHeader} from '../_helpers';
import {handleResponse} from '../_helpers';


export const customerService = {
    getCustomerCollection
};


async function getCustomerCollection() {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };

    let allCustomers = [];
    let currentPage = 1;
    let totalPages;

    do {
        const response = await fetch(`${process.env.VUE_APP_API_SERVER}/api/customers?page=${currentPage}`, requestOptions);
        const data = await handleResponse(response);

        if (currentPage === 1) {
            allCustomers = data
        } else {
            allCustomers['hydra:member'] = allCustomers['hydra:member'].concat(data['hydra:member']);
        }

        totalPages = Math.ceil(data['hydra:totalItems'] / 30);
        currentPage++;
    } while (currentPage <= totalPages);

    return allCustomers;
}